function toDateInputValue(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
}

function setDateInputLimits(dateFrom, dateTo) {
    const today = toDateInputValue(new Date());

    if (dateFrom) {
        dateFrom.max = today;
    }

    if (dateTo) {
        dateTo.max = today;
    }
}

function toggleDateRangeFilter(form) {
    const taskAgeInDays = form.querySelector('[data-role="task-age"]');
    const dateRangeFilter = form.querySelector('[data-role="date-range"]');
    const dateFrom = form.querySelector('[data-role="date-from"]');
    const dateTo = form.querySelector('[data-role="date-to"]');
    const isUserDefinedDateRange = taskAgeInDays?.value === "user_defined";

    if (taskAgeInDays) {
        taskAgeInDays.setAttribute("aria-expanded", String(isUserDefinedDateRange));
    }

    if (dateRangeFilter) {
        dateRangeFilter.hidden = !isUserDefinedDateRange;
        dateRangeFilter.setAttribute("aria-hidden", String(!isUserDefinedDateRange));
    }

    if (dateFrom) {
        dateFrom.disabled = !isUserDefinedDateRange;
    }

    if (dateTo) {
        dateTo.disabled = !isUserDefinedDateRange;
    }

    if (isUserDefinedDateRange && dateFrom && dateTo && !dateFrom.value && !dateTo.value) {
        const today = new Date();
        const dateFromValue = new Date(today);
        dateFromValue.setDate(today.getDate() - 30);

        dateFrom.value = toDateInputValue(dateFromValue);
        dateTo.value = toDateInputValue(today);
    }
}

function excludeEmptyOptionalFields(form) {
    const isUserDefinedDateRange = form.querySelector('[data-role="task-age"]')?.value === "user_defined";
    const optionalFields = [form.querySelector('[data-role="search-query"]')];
    const fieldsWithRemovedNames = [];

    if (isUserDefinedDateRange) {
        optionalFields.push(
            form.querySelector('[data-role="date-from"]'),
            form.querySelector('[data-role="date-to"]')
        );
    }

    for (const field of optionalFields) {
        if (field && !field.value.trim()) {
            fieldsWithRemovedNames.push({
                field,
                name: field.name
            });
            field.removeAttribute("name");
        }
    }

    return fieldsWithRemovedNames;
}

function restoreFieldNames(fieldsWithRemovedNames) {
    for (const entry of fieldsWithRemovedNames) {
        entry.field.name = entry.name;
    }
}

function initTicketsFilter(form) {
    if (form.dataset.ticketsFilterInitialized === "true") {
        return;
    }

    const taskAgeInDays = form.querySelector('[data-role="task-age"]');
    const dateFrom = form.querySelector('[data-role="date-from"]');
    const dateTo = form.querySelector('[data-role="date-to"]');

    setDateInputLimits(dateFrom, dateTo);
    toggleDateRangeFilter(form);

    taskAgeInDays?.addEventListener("change", () => {
        toggleDateRangeFilter(form);
    });

    form.addEventListener("submit", () => {
        const fieldsWithRemovedNames = excludeEmptyOptionalFields(form);

        requestAnimationFrame(() => {
            restoreFieldNames(fieldsWithRemovedNames);
        });
    });

    form.dataset.ticketsFilterInitialized = "true";
}

export function initTicketsFilters(root = document) {
    root.querySelectorAll('[data-tickets-filter]').forEach((form) => {
        initTicketsFilter(form);
    });
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initTicketsFilters);
} else {
    initTicketsFilters();
}
